import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface WaitingForHumanNotification {
    chatId: number
    phoneNumber: string
    name: string
    reason: string
    timestamp: string
}

interface NotificationsState {
    waitingForHuman: WaitingForHumanNotification[]
}

const initialState: NotificationsState = {
    waitingForHuman: [],
}

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        addWaitingForHuman: (
            state,
            action: PayloadAction<WaitingForHumanNotification>
        ) => {
            const exists = state.waitingForHuman.find(
                n => n.chatId === action.payload.chatId
            )
            if (!exists) {
                state.waitingForHuman.unshift(action.payload)
            }
        },
        removeWaitingForHuman: (state, action: PayloadAction<number>) => {
            state.waitingForHuman = state.waitingForHuman.filter(
                n => n.chatId !== action.payload
            )
        },
        clearWaitingForHuman: state => {
            state.waitingForHuman = []
        },
        clearAll: state => {
            state.waitingForHuman = []
        },
    },
})

export const {
    addWaitingForHuman,
    removeWaitingForHuman,
    clearWaitingForHuman,
    clearAll,
} = notificationsSlice.actions

export default notificationsSlice.reducer

